import { c as _c } from "react/compiler-runtime";
import { type InputProps } from 'react-select';
import { components } from 'react-select';
import { type Place } from '@/features/place/types/place-types';
export default function SearchPlaceInput(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <components.Input {...props} aria-activedescendant="" contentEditable={true} isHidden={false} hidden={false} inputMode="text" id="search-place" />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}